import React from "react";
import "./Dashboard.css";

const StatsCard = ({
  title,
  value,
  subLabel,
  percentage,
  isPositive,
  onClick,
  style,
}) => {
  return (
    <div className="stats-card" onClick={onClick} style={style}>
      <div>
        <div className="fs-22 fw">
          {value}
          {subLabel && (
            <span className="fs-10 text-muted ml-5">{subLabel}</span>
          )}
        </div>
        <div className="fs-14 text-muted">{title}</div>
      </div>
    </div>
  );
};

export default React.memo(StatsCard);
